export const autoLogout = {
  title: 'Still there?',
  content: 'If you haven’t interacted with the Carbon Counter for 5 minutes, you will automatically be logged out.',
  button: 'Stay logged in',
  slug: 'TIMEOUT',
};
